import React from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';

export default function Button(props) {
  // Render button
  return (
    <div
      className={clsx(
        styles.button,
        props.active && styles.active,
        'button',
        props.active && 'active'
      )}
      onClick={props.onClick}
    >
      {props.text}
    </div>
  );
}
